import { ResponseObject } from '#/interfaces';
import request from '#/utils/request';
import useSWR from 'swr';

export interface EthereumRewardsSummaryInfo {
  totalRewards: string;
  totalProtocolRewards: string;
  totalFeeMevRewards: string;
  yesterdayRewards: string;
}
/**
 * useEthereumRewardsSummary
 */
export default function useEthereumRewardsSummary() {
  return useSWR(
    '/api/v2/eth2/rewards/summary',
    url => request.post<ResponseObject<EthereumRewardsSummaryInfo>>(url),
    {
      refreshInterval: 60_000,
      keepPreviousData: true,
    }
  );
}
